const details = {
  sessions: {
      title: '分析セッション一覧',
      noSessions: '分析セッションがありません',
      createFirst: '最初の分析を開始してください',
      loadMore: 'もっと読み込む',
      delete: '削除',
      deleteConfirm: 'このセッションを削除してもよろしいですか？',
      view: '詳細を表示',
      resume: '再開',
    },
  errors: {
      createFailed: 'セッションの作成に失敗しました',
      analysisFailed: '分析に失敗しました',
      loadFailed: 'データの読み込みに失敗しました',
      exportFailed: 'エクスポートに失敗しました',
      connectionLost: '接続が切断されました。再試行してください',
      sessionLoadFailed: 'セッションの読み込みに失敗しました',
      sessionsFetchFailed: 'セッション一覧の取得に失敗しました',
      sessionDeleteFailed: 'セッションの削除に失敗しました',
      cadLinkFailed: 'CADリンクに失敗しました',
      analysisRequestFailed: '分析リクエストが失敗しました（HTTP {{status}}）',
      httpError: 'HTTPエラー（{{status}}）',
      noResponseBody: 'サーバーから応答本文が返りませんでした',
      allFieldsRequired: '必須項目をすべて入力してください',
      specsRequiredToResume: '分析を再開するには仕様書が必要です',
      noSessionToExport: 'エクスポートできるセッションがありません',
    },
  success: {
      analysisComplete: '分析が完了しました',
      exported: 'エクスポートが完了しました',
      sessionDeleted: 'セッションを削除しました',
    },
  knowledge: {
      title: '参照知識',
      references: '関連知識',
      document: 'ドキュメント',
      relevance: '関連度',
      snippet: '抜粋',
      noReferences: '関連する知識が見つかりませんでした',
    },
  confirm: {
      backToConditions: {
        title: 'ケース条件に戻る',
        description: '編集中の変更点は保存されていません。戻ると入力内容がすべて破棄され、この操作は取り消せません。戻ってもよろしいですか？',
        confirm: '破棄して戻る',
      },
      switchWorkflowMode: {
        title: '実行モードの切り替え',
        description: '進行中の工程別ワークフローが破棄されます。入力したテキストと進捗は復元できません。切り替えてもよろしいですか？',
        confirm: '切り替える',
      },
      normalMode: {
        title: '通常モードに戻る',
        description: '入力中の内容は保存されていません。モードを切り替えると破棄され、この操作は取り消せません。切り替えてもよろしいですか？',
        confirm: '切り替える',
      },
      regenerateStage: {
        title: '再生成の確認',
        description: 'すでに生成された候補のうち、まだ確認していないものは破棄され、新しい候補に置き換わります。この操作は取り消せません。再生成してもよろしいですか？',
        confirm: '再生成する',
      },
      regeneratePrecheck: {
        title: '事前確認を再生成',
        description: '変更点を保存すると事前確認項目が作り直され、入力済みの回答はすべて失われます。この操作は取り消せません。続行してもよろしいですか？',
        confirm: '続行する',
      },
    },
  case: {
      title: 'GDSケース作成',
      description: '図面ページとGDS移管時の変更概要を起点にDRBFMケースを作成します。',
      startCase: 'GDSケースで開始',
      normalMode: '通常DRBFMへ',
      referenceDrawing: '参照図面: {{page}}ページ目',
      documentId: '文書ID {{id}}',
      imageId: '画像ID {{id}}',
      fields: {
        title: 'ケースタイトル',
        productName: '製品',
        targetPart: '対象部品',
        changeSummary: '変更概要',
      },
      required: '{{field}}は必須です',
      extractChanges: '変更点を抽出',
      extractingChanges: '変更点を抽出中',
      reviewTitle: '変更点レビュー',
      reviewDescription: '抽出された技術変更点をDRBFM入力として整えます。',
      noChanges: '抽出された変更点はありません。',
      changeNumber: '変更点 {{number}}',
      confidence: '信頼度 {{value}}%',
      changedItem: '変更項目',
      oldSpecification: '旧仕様',
      newSpecification: '新仕様',
      technicalChange: '技術変更内容',
      backToConditions: 'ケース条件に戻る',
      generatingPrecheck: '事前確認を生成中',
      continueToPrecheck: '事前確認へ進む',
      precheckTitle: '事前確認',
      precheckDescription: '不明点を明示してからDRBFM分析へ進みます。',
      noPrecheckItems: '事前確認項目はありません。',
      answer: '回答',
      answerHelper: '入力すると回答済みになります',
      backToChangeReview: '変更点レビューに戻る',
      generatingDrbfm: 'DRBFM生成中',
      generateDrbfm: 'DRBFMを生成',
      answerRequired: 'すべての確認項目に回答するか、不明または該当なしを選択してください。',
      refetching: '再取得中',
      refetchResults: '結果を再取得',
      analyzingLabel: 'DRBFMケース分析中',
      exportMissing: 'エクスポート対象のDRBFM結果がありません',
      exportFailed: 'HTMLエクスポートに失敗しました',
      missingCase: 'ケースが作成されていません',
      missingAnalysisSession: '分析セッションが作成されていません',
      createCaseFailed: 'ケースの作成に失敗しました',
      generatePrecheckFailed: '事前確認の生成に失敗しました',
      fetchResultsFailed: '分析結果の取得に失敗しました',
      analyzeFailed: '分析に失敗しました',
      answerStatus: {
        unanswered: '未回答',
        answered: '回答済み',
        unknown: '不明',
        not_applicable: '該当なし',
      },
    },
  drawingEvidence: {
      title: '図面根拠',
      missingDocumentId: '図面根拠の文書IDがありません。',
      imageNotFound: '対象ページの画像が見つかりません。',
      imageLoadFailed: '図面画像を読み込めませんでした。',
      notLinked: '図面根拠はまだ紐付いていません。',
      openDocumentPage: '文書ページを開く',
      goToDocument: '文書へ',
      missingNormalizedBbox: '正規化されたbboxがないため、文書ページで根拠箇所を確認してください。',
    },
  decisionMemory: {
      title: '設計判断メモリ',
      close: '設計判断メモリを閉じる',
      selectFailureMode: '故障モードを選択してください。',
      severity: '重大度 {{value}}',
      evidenceAvailable: '根拠あり',
      drawingLinked: '図面リンク済み',
      questionsGenerated: '質問生成',
      knowledgeLinked: '関連知識と照合済み',
      knowledgeUnlinked: '関連知識は未紐付け',
      additionalReviewNeeded: '追加確認が必要',
      noAdditionalQuestions: '追加質問なし',
      reviewComment: '{{description}}はRPN {{rpn}}。{{evidenceText}}、{{questionText}}としてレビューしてください。',
      followUpQuestions: 'AI追加確認質問',
      usedPrecheckAnswers: '事前確認で使った回答',
      unresolvedAssumptions: '未確定の前提',
      relatedKnowledgeSummary: '関連知識サマリー',
      relevance: '関連度 {{value}}',
      confidence: '信頼度 {{value}}',
      confirmInDrawing: '図面で確認',
      decisionBasisTitle: 'AI案の理由と根拠',
      originatingChange: '起点となった変更点',
      changeDetailsUnavailable: '変更点の詳細は未取得です',
      causalHypothesis: 'AIが組み立てた因果仮説',
      cause: '原因仮説',
      failureMode: '故障モード候補',
      effect: '想定影響',
      recordedEvidence: '記録された因果根拠',
      evidenceNotGenerated: 'この候補を裏づける因果根拠はまだ記録されていません。因果関係は設計者が確認してください。',
      evidenceLevel: {
        direct: '直接根拠',
        supported: '補強根拠',
        assumption: '仮説',
      },
      evidenceBoundary: '関連資料 {{count}}件を参照したAI候補です。参照数は因果関係の裏づけを保証しません。妥当性は設計者が確認してください。',
      humanDecisionTitle: '設計者の判断',
      humanDecisionDescription: 'AI案をそのまま採用するか、修正指示から新しい案を作成して判断します。',
      adopt: '採用',
      adoptCandidate: 'このAI案を採用',
      readoptCandidate: '再検討して採用',
      rejectCandidate: '非採用',
      revisionInstruction: 'AIへの修正指示',
      revisionPlaceholder: '例: 原因をクランクシャフトの潤滑不足に絞り、影響を簡潔にしてください',
      generateRevision: 'AI修正案を作成',
      revisionPreview: 'AI修正案（未反映）',
      decisionBasis: '根拠',
      applyRevision: '修正案を採用して反映',
      discardRevision: '修正案を破棄',
      revisionFailed: 'AI修正案を作成できませんでした。',
      reviewFailed: '設計判断を保存できませんでした。',
      excludedHistory: '非採用・旧版 {{count}}件は一覧から除外し、判断履歴として保持しています。',
      showExcludedHistory: '非採用・旧版を表示',
      showActiveResults: '現在の結果に戻る',
      historyTitle: '判断履歴',
      historyDescription: '非採用・旧版として除外した内容です。非採用の変更点は再検討に戻し、故障モードは再検討して採用できます。',
      restoreForReview: '再検討に戻す',
      rejectedStatus: '非採用',
      supersededStatus: '旧版',
      rejectDesignChangeTitle: '変更点を非採用にしますか？',
      rejectDesignChangeDescription: 'この変更点を非採用にすると、関連する故障モード {{failureModes}}件と対策 {{countermeasures}}件も現在の結果から除外されます。判断履歴から再検討に戻せます。',
      rejectFailureModeTitle: '故障モードを非採用にしますか？',
      rejectFailureModeDescription: 'この故障モードを非採用にすると、関連する対策 {{countermeasures}}件も現在の結果から除外されます。判断履歴から再検討して採用できます。',
      confirmReject: '非採用にする',
    },
  cadLink: {
      parseError: '部位ラベルJSONを読み取れません',
      partsArrayRequired: 'parts配列、または部位ラベル配列を指定してください',
      duplicatePartLabel: '部位ラベル{{index}}の部位名が重複しています',
      invalidPartLabel: '部位ラベル{{index}}の形式が正しくありません',
      inputHelper: 'CADモデルを選ぶと、DRBFM解析完了後に3D上の該当部位へ自動リンクします',
      partLabelsJson: '部位ラベルJSON',
      partLabelsHelper: 'cover_part_labels.json全体、またはparts配列を貼り付けると優先ラベルとして使います',
      bulkView: '3Dで一括表示',
      unlinkedCount: '未リンクの失敗モードが{{count}}件あります。',
      partialResolved: 'CADリンクは一部未解決です: {{linked}}件リンク、{{unresolved}}件未解決',
      linkComplete: 'CADリンク完了: {{linked}}件リンク',
      linkCompleteWithUnresolved: 'CADリンク完了: {{linked}}件リンク、{{unresolved}}件未解決',
      linkFailedWithCode: 'CADリンクに失敗しました: {{code}}',
      noLinks: 'このDRBFM結果にはまだCADリンクがありません。',
      linkHelper: '選択したCADモデルに失敗モードをリンクします',
      linking: 'リンク中...',
      link: 'CADにリンク',
      labelEditor: {
        open: '3Dで部位を登録',
        title: '3Dで部位を登録',
        modelRequired: 'CADモデルを選択してください',
        modelLoadFailed: 'CADモデルの取得に失敗しました',
        selectedPoint: '選択位置',
        instructions: 'モデルを回転・拡大し、部位として登録する形状をクリックしてください。',
        position: '選択座標',
        noPointSelected: '未選択',
        labelName: '部位名',
        labelPlaceholder: '例: メインヒンジ',
        category: 'カテゴリ',
        categoryPlaceholder: '例: 回転・嵌合',
        note: 'メモ',
        requiredFields: 'CAD上の位置、部位名、カテゴリを入力してください',
        duplicateLabel: '同じ部位名がすでに登録されています',
        add: '部位を追加',
        registered: '登録する部位',
        empty: '登録済みの部位はありません',
        delete: '部位を削除',
        apply: 'ラベルを反映',
      },
      view3DTooltip: '3Dビューアで該当部位を表示',
      view3DUnavailable: 'CADモデルが紐付いていない、またはセッションIDが未指定',
      view3DLabel: '3Dで見る',
      selectFailureModeLabel: '故障モードを選択: {{description}}',
      designChangeExpand: '設計変更詳細を開く',
      designChangeCollapse: '設計変更詳細を閉じる',
      failureModeExpand: '故障モード詳細を開く',
      failureModeCollapse: '故障モード詳細を閉じる',
    },
  convert: {
      dialogTitle: '検証項目に変換',
      buttonLabel: '検証項目に変換',
      steps: {
        selectFailureModes: '故障モード選択',
        chooseTarget: '追加先を選択',
        preview: 'プレビュー',
      },
      classifications: {
        performance: '性能',
        function: '機能',
        reliability: '信頼性',
        safety: '安全性',
        cost: 'コスト',
        maintenance: '保守',
      },
      methods: {
        analysis: '解析',
        pre_test: '事前テスト',
        actual_confirm: '実機確認',
        dr1: 'DR1',
        design_calc: '設計計算',
        knowhow: 'ノウハウ',
      },
      fetchSessionsFailed: '検証セッション一覧の取得に失敗しました',
      convertFailed: '検証項目への変換に失敗しました',
      defaultSessionTitle: 'DRBFM連携: {{itemName}}',
      selectFailureModesDescription: '変換対象の故障モードを選択してください（{{selected}}/{{total}}件選択中）',
      selectAll: '全選択',
      deselectAll: '全解除',
      existingSession: '既存セッションに追加',
      verificationSession: '検証セッション',
      unit: 'ユニット',
      createNewUnit: '新規ユニット作成',
      newSession: '新規セッション作成',
      sessionTitle: 'セッションタイトル',
      modelName: '機種名',
      modelNamePlaceholder: '例: VARIAXIS i-800 NEO',
      unitNumber: 'ユニット番号',
      unitName: 'ユニット名',
      previewDescription: '以下の{{count}}件の検証項目が生成されます。',
      itemName: '項目名',
      classification: '分類',
      standardTarget: '基準・目標',
      verificationMethod: '検証手法',
      destination: '追加先:',
      destinationNew: '新規セッション「{{title}}」',
      destinationExisting: '既存セッション「{{title}}」',
      successTitle: '{{count}}件の検証項目を追加しました',
      successDescription: 'DRBFM分析結果からの検証項目変換が完了しました。',
      viewVerificationItems: '検証項目一覧を表示',
      back: '戻る',
      next: '次へ',
      submitting: '変換中...',
      submit: '検証項目に追加',
    },
};

export default details;
